import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signIn, savePending2faToken } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const LoginPassword = () => {
    useBootstrapCSS();
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email || "";

    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [message, setMessage] = useState({ text: "", type: "" });
    const [isLoading, setIsLoading] = useState(false);

    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; Secure; SameSite=Strict";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: "Logging in...", type: "loading" });
        setIsLoading(true);

        try {
            const result = await signIn(email, password);

            if (result.token) {
                setMessage({ text: "Login successful!", type: "success" });
                localStorage.clear();
                localStorage.setItem("token", result.token);
                if (result.refreshToken) localStorage.setItem("refreshToken", result.refreshToken);
                window.location.href = "/dashboard";
            } else if (result.require_totp) {
                savePending2faToken(result.pending_2fa_token);
                setMessage({ text: "Authenticator code required. Redirecting...", type: "success" });
                navigate("/enter-totp");
            } else if (result.require_otp) {
                savePending2faToken(result.pending_2fa_token);
                setMessage({ text: "OTP required. Redirecting...", type: "success" });
                navigate("/enter-otp");
            } else if (result.require_totp_setup) {
                savePending2faToken(result.pending_2fa_token);
                setMessage({ text: "TOTP setup required. Redirecting...", type: "success" });
                navigate("/totp-setup");
            } else {
                setMessage({ text: "Login failed: Unexpected response", type: "fail" });
                setIsLoading(false);
            }
        } catch (error) {
            setMessage({ text: `Login failed: ${error.message}`, type: "fail" });
            setIsLoading(false);
        }
    };

    const getMessageClass = () => {
        if (message.type === "success") return "successmessage";
        if (message.type === "loading") return "loadingmessage";
        return "failmessage";
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 px-5 form-outer h-100 align-items-center d-flex flex-column justify-content-center">
                        <form className="initial-form" onSubmit={handleSubmit}>
                            <h3 className="h3 mb-3">Login</h3>
                            <div className="form-group mb-20">
                                <label htmlFor="loginEmail">{email}</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="loginEmail"
                                    value={email}
                                    readOnly
                                />
                            </div>

                            <div className="form-group mb-3 password-wrap">
                                <label htmlFor="loginPassword">Password</label>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    id="loginPassword"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <i
                                    className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}
                                    id="togglePassword"
                                    onClick={() => setShowPassword(!showPassword)}
                                ></i>
                            </div>

                            {message.text && (
                                <div id="message" className={`p-2 ${getMessageClass()}`}>
                                    {message.text}
                                </div>
                            )}

                            <div className="form-group form-check d-flex justify-content-between mb-20">
                                <div>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="rememberMe"
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
                                </div>
                                <a href="/forgot-password">Forgot Password?</a>
                            </div>

                            <div className="form-group form-check mb-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="termsCheckbox"
                                    checked={termsAccepted}
                                    onChange={(e) => setTermsAccepted(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="termsCheckbox">
                                    I have read and accept the{" "}
                                    <a
                                        href="https://coddocument.blob.core.windows.net/serviceaggreement/Compliance%20on%20Demand%20-%20AML%20Dealchecker%20MSA%20-%20Finalised%20template%2019-12-2024%5B37%5D.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Terms and Conditions
                                    </a>
                                </label>
                            </div>

                            <div className="w-100 d-inine">
                                <button
                                    type="submit"
                                    className="btn btn-primary mb-20"
                                    disabled={!termsAccepted || isLoading}
                                >
                                    Log In
                                </button>
                            </div>

                        </form>
                        <div className="form-footer">
                            <div className="d-flex justify-content-center">
                                <p className="text-muted">
                                    Don't have an account ?{" "}
                                    <a href="/signup" className="text-decoration-none">SignUp here</a>
                                </p>
                            </div>
                            <p>Copyright &copy; {new Date().getFullYear()} Compliance on Demand All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoginPassword;
